<!-- 
	Modal
	props: N/A
  role: Public
	Modal alert that is used across the application to display errors/information to the users
  Accepts plain HTML including inline styling
-->

<template>
	<div class="modal text-white flex justify-center z-50">
		<div class="error-box fixed p-4 pb-8 w-3/4 sm:w-1/2">
			<div class="text-right text-lg icon">
				<i class="far fa-times-circle" @click="dropError"></i>
			</div>
			<div v-html="error"></div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";

	export default {
		name: "Modal",
		computed: {
			...mapGetters({
				error: "error",
			}),
		},
		mounted() {
			this.closeError();
		},
		methods: {
			dropError: function() {
				// user action to close error
				this.$store.commit("DROP_ERROR");
			},

			closeError: function() {
				// remove error after 10 seconds
				setTimeout(() => {
					this.dropError();
				}, 10000);
			},
		},
	};
</script>

<style scoped>
	.error-box {
		background-color: #1a1f56;
	}

	.icon {
		cursor: pointer;
	}
</style>
